"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_PRODUCT_SENTINEL = void 0;
/**
 * Marker the composer appends to a message when the user picks "No product" in the
 * searchProducts picker - the agent reads it as "work at brand level, no product scope".
 */
exports.NO_PRODUCT_SENTINEL = 'NO_PRODUCT_SELECTED';
